module.exports = __webpack_public_path__ + "img/credit-card-chip.a89880f0.png";